"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAppBaseInvocationRequestId = createAppBaseInvocationRequestId;
/**
 * Creates an App Container invocation request id: an RFC 4122 version 4 UUID
 * built from 16 bytes of `crypto.getRandomValues`. Browsers expose
 * `getRandomValues` in every context, also on plain http, while
 * `crypto.randomUUID` exists only in secure contexts.
 *
 * Self-contained on purpose: the App bridge embeds it via
 * `Function.prototype.toString`.
 */
function createAppBaseInvocationRequestId(random) {
    const bytes = random.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0'));
    return [
        hex.slice(0, 4).join(''),
        hex.slice(4, 6).join(''),
        hex.slice(6, 8).join(''),
        hex.slice(8, 10).join(''),
        hex.slice(10).join(''),
    ].join('-');
}
